import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ChangePass from './components/ChangePass';

const ChangePassword = () => (
    <div className="account">
        <div className="account__wrapper">
            <div className="account__card">
                <div className="account__profile">
                    <h3>Cambiar Contraseña</h3>
                </div>
                <ChangePass />
            </div>
        </div>
    </div>
);

export default ChangePassword;